module.exports = __webpack_public_path__ + "896f01d50832bea7eccc66e74403ee87.fbx";